import { render, staticRenderFns } from "./SetProductType.vue?vue&type=template&id=0179dca6&scoped=true&"
import script from "./SetProductType.vue?vue&type=script&lang=js&"
export * from "./SetProductType.vue?vue&type=script&lang=js&"
import style0 from "./SetProductType.vue?vue&type=style&index=0&id=0179dca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179dca6",
  null
  
)

export default component.exports